import React from "react";
import AccordionFooter from "./AccordionFooter";

import video from "assets/img/video.webp";
import linkedin1 from "assets/img/linkedin-logo.webp";
import facebook1 from "assets/img/facebook1.webp";
import instagram1 from "assets/img/instagram1.webp";
import logowhite from "assets/img/new/logowhite.webp";

export default function Footer2() {
  {
    const accordionData = [
      {
        title: "QUICK MENU",
        content: [
          <ul key="list">
            <li className="text-xs font py-2">
              <a href="/Homepage1">Home</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/ourstory">About Us</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/entrepreneurial-preschool">Way of Learning</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/faqs">FAQ's</a>
            </li>

            <li className="text-xs font py-2">
              <a href="/career">Careers</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/contact">Contact Us</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/gridblog">Blog</a>
            </li>
          </ul>,
        ],
      },

      {
        title: "WAY OF LEARNING",
        content: [
          <ul key="list">
            <li className="text-xs font py-2">
              <a href="/entrepreneurial-preschool">
                Pedagogy partner - Antah:Prerana
              </a>
            </li>
            <li className="text-xs font py-2">
              <a href="/entrepreneurial-preschool">
                An Award Winning Curriculum
              </a>
            </li>
            <li className="text-xs font py-2">
              <a href="/entrepreneurial-preschool">
                Curriculum and Teaching Methodology Entrepreneurial Skills
              </a>
            </li>
            <li className="text-xs font py-2">
              <a href="/entrepreneurial-preschool">
                Technology of Consciousness
              </a>
            </li>
            <li className="text-xs font py-2">
              <a href="/entrepreneurial-preschool">Modality of Consciousness</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/entrepreneurial-preschool">
                Curriculum and Teaching Methodology
              </a>
            </li>
          </ul>,
        ],
      },

      

      {
        title: "CAREERS",
        content: [
          <ul key="list">
            <li className="text-xs font py-2">
              <a href="/career">Job Opportunities at Junior Toes</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/head-of-school">Head of School Pre- Primary</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/pre-primary-facilitators">Facilitators</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/admission-manager">Admission Manager</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/operation-manager">Operational Manager</a>
            </li>
          </ul>,
        ],
      },

      {
        title: "WHY JUNIOR TOES",
        content: [
          <ul key="list">
            <li className="text-xs font py-2">
              <a href="/foundation">Entrepreneurial Foundation</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/foundation">Technology of Consciousness</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/foundation">Modality of Consciousness</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/foundation">Play With Purpose</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/foundation">Nature and Environment Focus</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/foundation">Skill-Based Learning</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/foundation">Freedom to Grow</a>
            </li>
          </ul>,
        ],
      },


      {
        title: "contact us",
        content: [
          <ul key="list">
            <li className="text-xs font py-2">
              <a href="/">SAS DREAM EDUCATION PVT LTD 81/1, No 20, Hebbagodi Srinivasa
Layout, Hesaraghatta Main Road,
Bangalore – 560057</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/">+91-9035039983</a>
            </li>
            <li className="text-xs font py-2">
              <a href="/">
              info@juniortoes.com</a>
            </li>
            
          </ul>,
        ],
      },
    ];
    return (
      <>
        <footer className="bgfooter pt-8 pb-6 mb-36 xl:hidden lg:hidden md:block sm:block block">
          <div className="xl:hidden lg:hidden md:block block sm:block ">
            <div className="app px-4">
              {accordionData.map((item, index) => (
                <AccordionFooter
                  key={index}
                  title={item.title}
                  content={item.content}
                />
              ))}
              <div className="">
                <h2 className="xl:text-sm text-sm font-semibold text-white text-center mt-4">
                  © Junior Toes 2024. All rights reserved.
                </h2>
                <div className="flex justify-center items-center mt-4 gap-2">
                  <h2 className="text-xs  font-semibold text-white">
                    Privacy Policy
                  </h2>
                  <h2 className=" text-xs font-semibold text-white">
                    Terms and Conditions
                  </h2>
                </div>

                <div className="flex  justify-center items-center mt-4 gap-2 ">
                  <div className="center-button">
                    <img className="w-5" src={facebook1} alt="" />
                  </div>

                  <a
                    href="https://www.instagram.com/juniortoes?igsh=MXNxMTJmMG00bDV5eg=="
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div>
                      <img className="w-5" src={instagram1} alt="" />
                    </div>
                  </a>
                  <div>
                    <img className="w-5" src={video} alt="" />
                  </div>

                  <a
                    href="https://www.linkedin.com/company/juniortoes/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div>
                      <img className="w-5" src={linkedin1} alt="" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>

        <section className="bgfooter parkinsans xl:block lg:block md:hidden sm:hidden hidden">
          <div className=" container mx-auto xl:py-12 lg:py-12 xl:px-0 lg:px-4">
            <div>
              <div className="grid grid-cols-2">
                <div className="xl:w-5/12 lg:w-5/12">
                  <a href="/Homepage1">
                    <img
                      class="xl:w-12/12 xl:-ml-4 lg:w-12/12 lg:-mt-4 xl:mt-0 lg:-ml-4"
                      src={logowhite}
                      alt=""
                    />
                  </a>
                </div>

                <div>
                  <div className="flex  justify-end xl:pt-8 gap-4 ">
                    <div className="center-button">
                      <img className="xl:ml-2 xl:w-8" src={facebook1} alt="" />
                    </div>
                    <a
                      href="https://www.instagram.com/juniortoes?igsh=MXNxMTJmMG00bDV5eg=="
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div>
                        <img
                          className="xl:ml-2 xl:w-8"
                          src={instagram1}
                          alt=""
                        />
                      </div>
                    </a>
                    <div>
                      <img className="xl:ml-2 xl:w-8" src={video} alt="" />
                    </div>
                    <a
                      href="https://www.linkedin.com/company/juniortoes/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div>
                        <img
                          className="xl:ml-2 xl:w-8"
                          src={linkedin1}
                          alt=""
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              <div
                className="border-t xl:mt-8 lg:mt-8"
                style={{ borderColor: "#e5e7eb52" }}
              >
                <div className="flex justify-between xl:mt-8 lg:mt-8 lg:gap-4 xl:gap-4">
                  <div className=" text-white">
                    <a>
                      <h2 className="uppercase xl:text-base lg:text-base  font-bold">
                        quick menu
                      </h2>
                    </a>
                    <a href="/Homepage1">
                      <p className="xl:mt-4 xl:text-sm text-sm font-semibold text-white">
                        Home
                      </p>
                    </a>
                    <a href="/ourstory">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        About Us
                      </p>
                    </a>
                    <a href="/entrepreneurial-preschool">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white">
                        Way of Learning
                      </p>
                    </a>
                    <a>
                      <a href="/faqs">
                        <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                          FAQ's
                        </p>
                      </a>
                    </a>
                    <a href="/career">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Careers
                      </p>
                    </a>
                    <a href="/gridblog">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Blog
                      </p>
                    </a>
                    <a href="/contact">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Contact Us
                      </p>
                    </a>
                  </div>

                  <div className="text-white">
                    <a href="/">
                      <h2 className="uppercase xl:text-base text-base font-bold">
                        WAY OF LEARNING
                      </h2>
                    </a>

                    <a href="/entrepreneurial-preschool">
                      <p className="xl:mt-4 xl:text-sm text-sm font-semibold text-white ">
                        Pedagogy partner - Antah:Prerana
                      </p>
                    </a>

                    <a href="/entrepreneurial-preschool">
                      <p className="xl:mt-2 xl:text-sm text-sm font-bold font-semibold text-white">
                        An Award Winning Curriculum
                      </p>
                    </a>
                    <a href="/entrepreneurial-preschool">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Curriculum and Teaching Methodology<br></br>{" "}
                        Entrepreneurial Skills
                      </p>
                    </a>
                    <a href="/entrepreneurial-preschool">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Technology of Consciousness
                      </p>
                    </a>
                    <a href="/entrepreneurial-preschool">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white">
                        Modality of Consciousness
                      </p>
                    </a>
                    <a href="/entrepreneurial-preschool">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white">
                        Curriculum and Teaching<br></br> Methodology
                      </p>
                    </a>
                  </div>
                  {/* <div className="text-white">
                    <h2 className="uppercase xl:text-base text-base font-bold">
                      ADMISSIONS
                    </h2>
                    <a href="/enroll-now">
                      <p className="xl:mt-4 xl:text-sm text-sm font-semibold text-white ">
                        Explore Our Philosophy
                      </p>
                    </a>
                    <a href="/enroll-now">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Schedule a Visit
                      </p>
                    </a>
                    <a href="/enroll-now">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white">
                        Inquiry form
                      </p>
                    </a>
                    <a href="/enroll-now">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Admission form Fees &<br></br> Tuition
                      </p>
                    </a>
                  </div> */}
                  <div className=" text-white">
                    <h2 className="uppercase xl:text-base text-base font-bold">
                      Careers
                    </h2>

                    <a href="/career">
                      <p className="xl:mt-4 xl:text-sm  text-sm font-semibold text-white ">
                        Job Opportunities at<br></br> Junior Toes
                      </p>
                    </a>
                    <a href="/head-of-school">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Head of School Pre-<br></br>Primary
                      </p>
                    </a>
                    <a href="/pre-primary-facilitators">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Facilitators
                      </p>
                    </a>
                    <a href="/admission-manager">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Admission Manager
                      </p>
                    </a>
                    <a href="/operation-manager">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Operational Manager
                      </p>
                    </a>
                  </div>
                  <div className=" text-white">
                    <h2 className="uppercase xl:text-base text-base font-bold">
                      why junior toes
                    </h2>
                    <a href="/foundation">
                      <p className="xl:mt-4 xl:text-sm text-sm font-semibold text-white">
                        Entrepreneurial Foundation
                      </p>
                    </a>
                    <a href="/foundation">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white">
                        Technology of Consciousness
                      </p>
                    </a>

                    <a href="/foundation">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Modality of Consciousness
                      </p>
                    </a>

                    <a href="/foundation">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Play With Purpose
                      </p>
                    </a>
                    <a href="/foundation">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Nature and Environment Focus
                      </p>
                    </a>

                    <a href="/foundation">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Skill-Based Learning
                      </p>
                    </a>
                    <a href="/foundation">
                      <p className="xl:mt-2 xl:text-sm text-sm font-semibold text-white ">
                        Freedom to Grow
                      </p>
                    </a>
                  </div>
                  <div className=" text-white">
                    <h2 className="uppercase xl:text-base text-base font-bold">
                      contact us
                    </h2>
                    <div class="space-y-3">
                      <div class="flex items-center gap-4 xl:mt-4">
                        <i class="fas fa-map-marker-alt text-white"></i>
                        <span className=" xl:text-sm text-sm font-semibold text-white">
                        SAS DREAM EDUCATION PVT LTD <br></br> 81/1, No 20, Hebbagodi Srinivasa <br></br>Layout,
                          Hesaraghatta Main Road,<br></br>
                          Bangalore – 560057
                        </span>
                      </div>
                      <div class="flex items-center gap-4 xl:mt-2">
                        <i class="fas fa-phone-alt text-white scale-x-[-1]"></i>
                        <span className="xl:text-sm text-sm font-semibold text-white">
                          +91-9035039983
                        </span>
                      </div>
                      <div class="flex items-center gap-4 xl:mt-2">
                        <i class="fas fa-envelope text-white"></i>
                        <span className=" xl:text-sm text-sm font-semibold text-white">
                          info@juniortoes.com
                        </span>
                      </div>
                      
                    </div>
                  </div>
                </div>
                <div className="bottom-0 xl:mt-16 lg:mt-12">
                  <div className="flex justify-between xl:mt-24">
                    <div className="">
                      <h2 className="xl:text-sm text-sm font-semibold text-white">
                        © Junior Toes 2024. All rights reserved.
                      </h2>
                    </div>
                    <div className="">
                      <div className="flex justify-between gap-4">
                        <h2 className="xl:text-sm text-sm text-right font-semibold text-white">
                          Privacy Policy
                        </h2>
                        <h2 className="xl:text-sm text-sm text-right font-semibold text-white">
                          Terms and Conditions
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
